import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar } from '@mui/material';
import iconA from '../assets/icons.png';

const Header = () => {
  const [animate, setAnimate] = useState(false);
  const location = useLocation();

  // const handleButtonClick = () => {
  //   setAnimate(true);
  //   setTimeout(() => setAnimate(false), 300);
  // };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px',height:'75px'}}>
      <Toolbar className="toolbar">
        <Link to="/">
          {iconA ? <img className='image-rabanot' src={iconA} alt="Icon A" /> : <div>Icon A not found</div>}
        </Link>
      </Toolbar>
    </div>
  );
};

export default Header;